import { render } from "./CreateTicket.vue?vue&type=template&id=4dad1d2a&scoped=true"
import script from "./CreateTicket.vue?vue&type=script&lang=js"
export * from "./CreateTicket.vue?vue&type=script&lang=js"

import "./CreateTicket.vue?vue&type=style&index=0&id=4dad1d2a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dad1d2a"]])

export default __exports__